import './../../styles/Dashboard.css';
import { useState } from 'react';
import { useToast } from '../../context/ToastProvider.js';
import config from '../../constants/config.js';

function ProductSync() {
    const addToast = useToast();

    const [ isSyncing, setIsSyncing ] = useState( false );

    async function handleClick( ) {
        setIsSyncing( true );
        
        try {
            let storeData = [];
            const storeMode = getMode();
            if ( storeMode === 'SINGLE' ) {
                const shopRef = getSingleSelectedStore();
                storeData = [ shopRef?.shop ];
            } else if ( storeMode === 'MULTI' ) {
                const shopRefList = getMultiSelectedStore();
                for ( let i = 0; i < shopRefList.length; i++ ) {
                    storeData.push( shopRefList[i]?.shop );
                }
            }
            
            const url = `${config.app.API_URL}/api/${config.app.REACT_APP_API_VERSION}/sync/products`;
            const requestSettings = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(
                    {
                        "shops": storeData
                    }
                )
            };
            const response = await fetch( url , requestSettings );
            const data = await response.json();
            if ( data?.errors?.length > 0 ) {
                addToast( `Product Sync Failed - ${data?.errors[0].message}`, true , 5000 );
            } else {
                addToast( 'Product Sync Finished', false , 5000 );
            }
        } catch ( error ) {
            console.log( error );
        } finally {
            setIsSyncing( false );
        }
        
        return;
    }

    function getSingleSelectedStore() {
        let store = JSON.parse( localStorage.getItem( 'single_store_selected' ) ) || null;
        return store;
    }

    function getMultiSelectedStore() {
        let stores = JSON.parse( localStorage.getItem( 'multi_stores_selected' ) ) || null;
        return stores;
    }

    function getMode() {
        let mode = localStorage.getItem( 'store_selection_mode' );
        return mode;
    }

    return(
        <button onClick={ handleClick } className="action-btn" disabled={isSyncing ? true : undefined}>
            <span className="icon"> 
                {isSyncing ? (
                    <svg width="15" height="15" viewBox="0 0 50 50" className="spinner">
                        <circle cx="25" cy="25" r="20" stroke="white" strokeWidth="5" fill="none" strokeDasharray="90 150" strokeLinecap="round">
                            <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="1s" repeatCount="indefinite" />
                        </circle>
                    </svg>
                ) : (
                    // Original sync icon
                    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.1953 8.52115C12.529 11.0553 10.2321 12.9231 7.5 12.9231C5.79241 12.9231 4.25558 12.1928 3.1808 11.0284L4.55357 9.64856C4.72433 9.47692 4.82143 9.24135 4.82143 8.99904C4.82143 8.49086 4.41295 8.08029 3.90737 8.08029L0.535714 8.07692C0.241071 8.07692 0 8.31923 0 8.61538V12.0043C0 12.5125 0.408482 12.9231 0.914062 12.9231C1.15513 12.9231 1.38951 12.8255 1.56027 12.6538L2.42076 11.7889C3.69308 13.1486 5.49777 14 7.5 14C10.7612 14 13.5 11.7452 14.2567 8.70288C14.3371 8.37644 14.0826 8.07692 13.7478 8.07692C13.4866 8.07692 13.2623 8.26538 13.1953 8.52115ZM11.8192 2.97163L10.4464 4.35144C10.2757 4.52308 10.1786 4.75865 10.1786 5.00096C10.1786 5.50913 10.5871 5.91971 11.0926 5.91971L14.4643 5.92308C14.7589 5.92308 15 5.68077 15 5.38462V1.99567C15 1.4875 14.5915 1.07692 14.0859 1.07692C13.8449 1.07692 13.6105 1.17452 13.4397 1.34615L12.5792 2.21106C11.3069 0.851442 9.50223 0 7.5 0C4.23884 0 1.5 2.25481 0.743304 5.29711C0.662946 5.62356 0.917411 5.92308 1.25223 5.92308C1.51339 5.92308 1.73772 5.73462 1.80469 5.47885C2.47098 2.94471 4.76786 1.07692 7.5 1.07692C9.20759 1.07692 10.7444 1.80721 11.8225 2.97163H11.8192ZM13.9286 4.84615H11.471L13.9286 2.37596V4.84615ZM1.07143 9.15385H3.52902L1.07143 11.624V9.15385Z" fill="white"/>
                    </svg>
                )}
            </span>
            <span className="title">{isSyncing ? "SYNCING..." : "PRODUCT SYNC"}</span>
        </button>
    );
}

export default ProductSync;